import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr.json';
import es from './es.json';

// Detect language from URL on initialization  
const detectLanguageFromUrl = () => {
  const pathname = window.location.pathname;
  if (pathname.startsWith('/es')) {
    return 'es';
  }
  return 'fr';
};

const initialLanguage = detectLanguageFromUrl();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        translation: fr
      },
      es: {
        translation: es
      }
    },
    lng: initialLanguage, // Use detected language from URL
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

// Listen for URL changes to update language
window.addEventListener('popstate', () => {
  const newLanguage = detectLanguageFromUrl();
  if (i18n.language !== newLanguage) {
    i18n.changeLanguage(newLanguage);
  }
});

export default i18n;